import React from 'react';
import { StyledBadge } from './LiveBadge.styles';

const LiveBadge = ({ item, size }) => {
    return (
        <StyledBadge
            text={item?.badge?.text}
            theme={item?.badge?.type}
            accessibilityText={item?.badge?.altText}
            overlay
            size={size}
        />
    );
};

export default LiveBadge;
